import { render, staticRenderFns } from "./ComplainList.vue?vue&type=template&id=3245bc0e&scoped=true&"
import script from "./ComplainList.vue?vue&type=script&lang=js&"
export * from "./ComplainList.vue?vue&type=script&lang=js&"
import style0 from "./ComplainList.vue?vue&type=style&index=0&id=3245bc0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../liveec/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3245bc0e",
  null
  
)

export default component.exports